<template>
  <input
    class="question-checkbox"
    type="checkbox"
    :checked="checked"
    :disabled="disabled"
    @change="handleChange"
  >
</template>

<script>
export default {
  name: 'CheckboxControl',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(event) {
      const checked = event.target.checked
      this.$emit('input', checked)
      this.$emit('change', checked)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/tokens';

.question-checkbox {
  appearance: none;
  position: relative;
  display: inline-grid;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  margin: 0;
  padding: 0;
  border: 2px solid $color-border-dark;
  border-radius: 5px;
  background: $color-surface;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.question-checkbox::before {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 9px;
  border: solid $color-surface;
  border-width: 0 2px 2px 0;
  content: '';
  transform: translate(-50%, -58%) rotate(45deg) scale(0);
  transform-origin: center;
  transition: transform 0.16s ease;
}

.question-checkbox:checked {
  border-color: $color-primary;
  background: $color-primary;
  box-shadow: 0 0 0 3px rgba($color-primary, 0.1);
}

.question-checkbox:checked::before {
  transform: translate(-50%, -58%) rotate(45deg) scale(1);
}

.question-checkbox:hover:not(:disabled) {
  border-color: $color-primary;
  transform: translateY(-1px);
}

.question-checkbox:focus-visible {
  border-color: $color-primary;
  outline: none;
  box-shadow: 0 0 0 4px rgba($color-primary, 0.16);
}

.question-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
